export function SessionTrashIcon() {
  return (
    <svg
      preserveAspectRatio="none"
      overflow="visible"
      style={{ display: 'block' }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Sign out</title>
      <g id="trash3">
        <path
          id="Vector (Stroke)"
          d="M10.5 5H13.5C13.7761 5 14 5.22386 14 5.5V6.5H10V5.5C10 5.22386 10.2239 5 10.5 5ZM15 6.5V5.5C15 4.67157 14.3284 4 13.5 4H10.5C9.67157 4 9 4.67157 9 5.5V6.5H6.50566C6.50226 6.49997 6.49885 6.49997 6.49544 6.5H5.5C5.22386 6.5 5 6.72386 5 7C5 7.27614 5.22386 7.5 5.5 7.5H6.0384L6.89116 18.1595C6.97431 19.1989 7.84207 20 8.88479 20H15.1152C16.1579 20 17.0257 19.1989 17.1088 18.1595L17.9616 7.5H18.5C18.7761 7.5 19 7.27614 19 7C19 6.72386 18.7761 6.5 18.5 6.5H17.5046C17.5011 6.49997 17.4977 6.49997 17.4943 6.5H15ZM16.9584 7.5L16.112 18.0797C16.0704 18.5994 15.6366 19 15.1152 19H8.88479C8.36343 19 7.92955 18.5994 7.88798 18.0797L7.0416 7.5H16.9584ZM9.47064 8.50086C9.74631 8.48465 9.98292 8.69497 9.99914 8.97064L10.4991 17.4706C10.5154 17.7463 10.305 17.9829 10.0294 17.9991C9.7537 18.0154 9.51708 17.805 9.50086 17.5294L9.00086 9.02936C8.98465 8.7537 9.19497 8.51708 9.47064 8.50086ZM14.5294 8.50086C14.805 8.51708 15.0154 8.7537 14.9991 9.02936L14.4991 17.5294C14.4829 17.805 14.2463 18.0154 13.9706 17.9991C13.695 17.9829 13.4846 17.7463 13.5009 17.4706L14.0009 8.97064C14.0171 8.69497 14.2537 8.48465 14.5294 8.50086ZM12 8.5C12.2761 8.5 12.5 8.72386 12.5 9V17.5C12.5 17.7761 12.2761 18 12 18C11.7239 18 11.5 17.7761 11.5 17.5V9C11.5 8.72386 11.7239 8.5 12 8.5Z"
          fill="#E0301E"
        />
      </g>
    </svg>
  );
}
